import axiosInstance from './AxiosInstance';

export default class WalletService {
    static async getTokenBalance() {
        const axiosResponse = await axiosInstance.get(`/wallet/balance-token`);

        return axiosResponse.data;
    }
}